<template>
  <!-- 投资机构详情 -->
  <div class="InstitutionalInvestor">
    <Head />
    <!-- 投资机构详情的头部nav -->

    <DockingSystemHead />

    <!-- 投资机构详情上部 -->
    <InstitutionalInvestorTop :msg="VCData" />

    <!-- 投资机构详情中部 -->
    <!-- <InstitutionalInvestorCenter /> -->

    <!-- 投资机构详情底部 -->
    <InstitutionalInvestorBottom  :msg="VCData" />

    <Foot />


   
  </div>
</template>

<script>
import Head from "@/components/Head/Head.vue";
import Foot from "@/components/Foot/Foot.vue";
import DockingSystemHead from "@/components/DockingSystem/Head/DockingSystemHead.vue"; //投资机构详情的头部nav
import InstitutionalInvestorTop from "@/components/DockingSystem/InstitutionalInvestor/InstitutionalInvestorTop.vue"; //投资机构详情上部
// import InstitutionalInvestorCenter from "@/components/DockingSystem/InstitutionalInvestor/InstitutionalInvestorCenter.vue"; //投资机构详情中部
import InstitutionalInvestorBottom from "@/components/DockingSystem/InstitutionalInvestor/InstitutionalInvestorBottom.vue"; //投资机构详情底部

import axios from "axios"


export default {
  props: {},
  components: {
    Head,
    Foot,
    DockingSystemHead,
    InstitutionalInvestorTop,
    // InstitutionalInvestorCenter,
    InstitutionalInvestorBottom,
  },
  data() {
    return {
      VCData:{},//投资机构数据
    //   // loginType:false,//登录状态,false为未登录
    //   loginType:true,//登录状态,true为已登录
    //   BusinessDetailsToplist: [
    //     {
    //       title: "医儿易",
    //       logoUrl: "../../../../public/static/images/yiErYi-logo.png",
    //       msg: "医儿易， 让孩子看病更容易",
    //       tags: ["医疗健康", "Pre-A", "北京市", "Pre-A", "2017年成立"],
    //     },
    //   ],
    };
  },
  created: function () {
    let id = this.$route.query.id;
      // console.log('this.$route', this.$route.query.id);
    this.getVC(id);

  },
  methods: {

    getVC(id) {
        let self = this;
        //获取投资机构详情
        axios.get('/api/jointorganizationdetails', {
          params: {
            id: id
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {
              self.VCData = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
  },
};
</script>

<style scoped>
.InstitutionalInvestor {
}
</style>